import { render, staticRenderFns } from "./sub-banner.vue?vue&type=template&id=38eb5f4d&scoped=true&functional=true&"
import script from "./sub-banner.vue?vue&type=script&lang=ts&"
export * from "./sub-banner.vue?vue&type=script&lang=ts&"
import style0 from "./sub-banner.vue?vue&type=style&index=0&id=38eb5f4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "38eb5f4d",
  null
  
)

export default component.exports